module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Light-54469e3c52efb3dffc83b8373749f46f.woff2";